import React, { useEffect, useRef, useState } from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { /*  useDrag,  */ useTouchDrag } from '../hooks/Slider';

interface IProps {
  slideItems?: number;
  children: React.ReactNode;
}

const Slider: React.FC<IProps> = ({ slideItems = 1, children }) => {
  // const { dragStart, dragStop, dragMove, dragging } = useDrag();
  const { touchDragStart, touchDragStop, touchDragMove /* touching */ } = useTouchDrag();
  const [currentIndex, setCurrentIndex] = useState(0);
  const contaninerRef = useRef<HTMLDivElement | null>(null);
  const innerRef = useRef<HTMLDivElement | null>(null);
  const [isFirstItemVisible, setIsFirstItemVisible] = useState(true);
  const [isLastItemVisible, setIsLastItemVisible] = useState(true);
  const [itemWidth, setItemWidth] = useState(0);

  let options = {
    root: contaninerRef.current,
    rootMargin: '0px',
    threshold: 0.95
  };

  const callback = (entries: any) => {
    entries.forEach((entry: any) => {
      if (innerRef.current) {
        if (entry.target === innerRef?.current.children[0]) {
          if (entry.isIntersecting) {
            setIsFirstItemVisible(true);
          } else {
            setIsFirstItemVisible(false);
          }
        }
        if (entry.target === innerRef?.current.children[innerRef?.current.children.length - 1]) {
          if (entry.isIntersecting) {
            setIsLastItemVisible(true);
          } else {
            setIsLastItemVisible(false);
          }
        }
      }
    });
  };

  useEffect(() => {
    let first: Element;
    let last: Element;
    if (innerRef.current) {
      first = innerRef.current.children[0];
      last = innerRef.current.children[innerRef.current.children.length - 1];
      const observer = new IntersectionObserver(callback, options);
      observer.observe(first);
      observer.observe(last);

      setItemWidth(
        Number(first.clientWidth) +
          Number(window.getComputedStyle(first).marginRight.replace(/px/g, '')) +
          Number(window.getComputedStyle(first).marginLeft.replace(/px/g, ''))
      );
      return () => {
        observer.unobserve(first);
        observer.unobserve(last);
      };
    }
  }, [innerRef, contaninerRef, options]);

  // const handleDrag = (ev: React.MouseEvent) => {
  //   dragMove(ev, (posDiff) => {
  //     if (contaninerRef.current) {
  //       contaninerRef.current.scrollLeft += posDiff;
  //     }
  //   });
  // };

  const handleTouch = (e: React.TouchEvent<HTMLDivElement>) => {
    touchDragMove(e, (posDiff: any) => {
      if (contaninerRef.current) {
        contaninerRef.current.scrollLeft += posDiff;
        contaninerRef.current.scroll({
          behavior: 'smooth'
        });
      }
    });
  };

  const [mouseDown, setMouseDown] = useState(false);
  const [mousePos, setMousePos] = useState({
    startX: 0,
    scrollLeft: 0
  });

  let startDragging = function (e: any) {
    if (contaninerRef.current) {
      setMouseDown(true);
      let startX = e.pageX - contaninerRef.current.offsetLeft;
      let scrollLeft = contaninerRef.current.scrollLeft;
      setMousePos({
        startX,
        scrollLeft
      });
    }
  };

  let stopDragging = function (/* event: any */) {
    setMouseDown(false);
  };

  const handleMove = (e: any) => {
    if (contaninerRef.current) {
      e.preventDefault();
      if (!mouseDown) {
        return;
      }
      const x = e.pageX - contaninerRef.current.offsetLeft;
      const scroll = x - mousePos.startX;
      contaninerRef.current.scrollLeft = mousePos.scrollLeft - scroll;
    }
  };

  return (
    <div
      onMouseDown={startDragging}
      onMouseMove={handleMove}
      onMouseLeave={stopDragging}
      onMouseUp={stopDragging}
      onMouseUpCapture={stopDragging}
      onTouchStart={touchDragStart}
      onTouchMove={handleTouch}
      onTouchEnd={touchDragStop}
      onTouchCancel={touchDragStop}
      className="cursor-grabbing"
    >
      <div className={`relative w-full h-full`}>
        {!isFirstItemVisible && (
          <button className="absolute h-full flex items-center justify-center -left-0 md:-left-0 outline-none">
            <BsChevronLeft
              onClick={() => (currentIndex > 0 ? setCurrentIndex(currentIndex - 1) : setCurrentIndex(0))}
              className="text-3xl md:text-4xl bg-primaryPink text-white z-20 rounded-full p-2 cursor-pointer"
            />
          </button>
        )}
        <div className={`w-full relative h-full min-h-fit overflow-hidden`} ref={contaninerRef}>
          <div
            className={`w-full h-full flex relative transition-all gap-5`}
            ref={innerRef}
            style={{ left: `-${currentIndex * itemWidth * slideItems}px` }}
          >
            {children}
          </div>
        </div>
        {!isLastItemVisible && (
          <button className="absolute h-full flex items-center justify-center right-0 md:-right-0 top-0 outline-none">
            <BsChevronRight
              onClick={() => setCurrentIndex(currentIndex + 1)}
              className="text-3xl md:text-4xl bg-primaryPink text-white z-20 rounded-full p-2 cursor-pointer"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default Slider;
